import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ModalPopupsService {

  constructor(private api: ApiService) {}
  checkLoanOptionsEnteredData
  hawaiiMinAmount = '$1,600'
  hawaiiMinValue
  requiredMinAmount
  requiredMinValue 
  loanMinValue = '1000'
  loanMinAmount = '$1,000'
  loanMaxValue = '7500'
  loanMaxAmount = '$7,500'

  createAmountLine(val){
    return (val + '').length > 3 ? '$' + (+val + '').slice(0, (+val + '').length -3) + ',' + (+val + '').slice((+val + '').length - 3) : '$' +  val 
  }

  createLoanValue(min, max){
    // console.log(min, max)
    this.loanMinValue = min
    this.loanMinAmount = this.createAmountLine(min)
    this.loanMaxValue = max
    this.loanMaxAmount = this.createAmountLine(max)
  } 
  changeValue(val, type?){
    if(type === "HI") {
    this.hawaiiMinAmount = this.createAmountLine(val)
    this.hawaiiMinValue = +val
    } else {
      this.requiredMinValue = +val
      this.requiredMinAmount = this.createAmountLine(val)
      // (val + '').replace(/[0-9]/g, "X")
    }
  }

  async isStateAvailable(state): Promise<any> {
    try {
      const res: any = await this.api.checkStateAvailable(state).toPromise()
      if (res?.data?.isServiceAvailable) {
        if(res.data.popUps && res.data.popUps[0]) {
          return res.data.popUps[0].data
        }
        // if(res.data.popUps && res.data.popUps[0]) {
        //   return res.data.popUps[0].data
        // }
        return true
      }
    } catch (err) {
      // this.logger.error(err)
    }
    return false
  }
    // const isStateAv = await this.isStateAvailable(obj.info.address.state)
}
